import SelectOption from '../../../infrastructure/types/SelectOption';
import stringHelper from '../../../infrastructure/helpers/common/stringHelper';
import Selector from '../../../types/report/Selector';
import ComponentType from '../../../types/report/ComponentType';
import assignmentHelper from '../../../infrastructure/helpers/functions/assignment/assignmentHelper';

const createSelectorOption = (selector: Selector, name: string): SelectOption => {

    return {
        value: selector.number?.toString(),
        text: stringHelper.isNonEmpty(selector.name) ? selector.name : name
    };
};

const setEmptySelectorKeysByComponentType = (componentType: ComponentType, selectors: Selector[]): Selector[] => {

    selectors.forEach((selector) => {
        if (!selector.keys) {
            switch (componentType) {
                case ComponentType.AnnaDsbUpiEnrichmentSelector: selector.keys = [
                    {
                        name: 'CFI',
                        assignment: assignmentHelper.getEmptyAssignment(),
                        errors: [],
                        lastUpdatedTime: undefined
                    },
                    {
                        name: 'ISIN',
                        assignment: assignmentHelper.getEmptyAssignment(),
                        errors: [],
                        lastUpdatedTime: undefined
                    }
                ]; break;

                case ComponentType.FirdsFcaInstrumentSelectors:
                case ComponentType.FirdsEsmaInstrumentSelectors: selector.keys = [
                    {
                        name: 'InstrumentName',
                        assignment: assignmentHelper.getEmptyAssignment(),
                        errors: [],
                        lastUpdatedTime: undefined
                    },
                    {
                        name: 'Venue',
                        assignment: assignmentHelper.getEmptyAssignment(),
                        errors: [],
                        lastUpdatedTime: undefined
                    }
                ]; break;

                default: break;
            }
        }
    });

    return selectors;
}

export { createSelectorOption, setEmptySelectorKeysByComponentType }